import { render } from "./DepartmentCreate.vue?vue&type=template&id=1eb57268&scoped=true"
import script from "./DepartmentCreate.vue?vue&type=script&lang=js"
export * from "./DepartmentCreate.vue?vue&type=script&lang=js"

import "./DepartmentCreate.vue?vue&type=style&index=0&id=1eb57268&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb57268"]])

export default __exports__